import ErrorMessageConstants from '../../../constants/ErrorMessageConstants';
import { Box, Button, ButtonGroup, Text, TextButton } from '@zillow/constellation-10';

export type ModalFooterProps = {
  onCancel?: (() => void) | null;
  onCancelDataEventId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (...args: Array<any>) => void;
  onSubmitDataEventId?: string;
  submitText?: string;
  cancelText?: string;
  cancelButtonType?: string;
  cancelType?: 'reset' | 'button';
  errorMessage?: string | null;
  isSubmitting?: boolean;
  hasError?: boolean;
  isSubmitDisabled?: boolean;
};

const ModalFooter = ({
  onCancel = null,
  onCancelDataEventId,
  onSubmit,
  onSubmitDataEventId,
  submitText = 'Confirm',
  cancelText = 'Cancel',
  cancelType = 'button',
  errorMessage = '',
  isSubmitting = false,
  hasError = false,
  isSubmitDisabled = false,
}: ModalFooterProps): JSX.Element => (
  <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
    {hasError && (
      <Box css={{ paddingBottom: 'sm' }}>
        <Text css={{ color: 'red.600' }}>{errorMessage || ErrorMessageConstants.DEFAULT_ERROR}</Text>
      </Box>
    )}

    <ButtonGroup aria-label="controls">
      {onCancel && (
        <TextButton
          data-testid="cancel-button"
          aria-label="Cancel"
          tabIndex={0}
          tone="brand"
          onClick={onCancel}
          disabled={isSubmitting}
          type={cancelType}
          data-eventid={onCancelDataEventId}
        >
          {cancelText}
        </TextButton>
      )}
      <Button
        data-testid="submit-button"
        tone="brand"
        emphasis="filled"
        onClick={onSubmit}
        disabled={isSubmitDisabled}
        loading={isSubmitting}
        data-eventid={onSubmitDataEventId}
      >
        {submitText}
      </Button>
    </ButtonGroup>
  </Box>
);

export default ModalFooter;
